import Image from '@/components/UI/Image';
import { createEFPic } from '@/utils/useEFPic';
import { useGlobal } from '@/utils/useGlobal';
import { List } from 'antd';
import { TextModule } from '..';
import css from './index.module.scss';
const defaultData = {
    guide: 'High-Efficiency Solar Cells',
    title: 'Capture more rays.',
    desc1: 'Made using highly efficient monocrystalline silicon cells. And with an exceptional energy conversion rate of 20-21%, you get more energy with every cell.',
    desc2: 'Plus, when connected to an EcoFlow solar generator, the Maximum Power Point Tracking (MPPT) algorithm auto-adjusts, guaranteeing a constant and stable power supply',
    supliment: '* All data is gathered under test conditions.',
    items: [
        {
            url: '/img/mobile/solarpanel/panel_01.png',
            guide: 'Charge a Delta mini in',
            titleLeft: 'Approx ',
            titleRight: '4 hours',
            desc: 'with 6 x 60W portable solar panels.',
        },
        {
            url: '/img/mobile/solarpanel/panel_02.png',
            guide: 'Charge a Delta mini in',
            titleLeft: 'Approx ',
            titleRight: '5 hours',
            desc: 'with 2 x 110W portable solar panels.',
        },
        {
            url: '/img/mobile/solarpanel/panel_03.png',
            guide: 'Charge a Delta mini in',
            titleLeft: 'Approx ',
            titleRight: '3.7 hours',
            desc: 'with 2 x 160W portable solar panels.',
        },
        {
            url: '/img/mobile/solarpanel/panel_04.png',
            guide: 'Charge a Delta mini in',
            titleLeft: 'Approx ',
            titleRight: '3 hours',
            desc: 'with 1 x 400W portable solar panel.',
        },
    ],
};

export default function ImgCellsWithText({ data = defaultData, textAlign = 'center', webpUrl = '' }: any) {
    const { Item } = List;
    const { useRouter } = useGlobal();
    const { locale } = useRouter();
    const { EFPic } = createEFPic(webpUrl);

    return (
        <div className={`${css.imgCellsWithText} imgCellsWithText container`}>
            <TextModule
                data={{ text: data.guide }}
                cssStyle={{
                    fontFamily: 'var(--font-family-SemiBold)',
                    lineHeight: '.2rem',
                    fontSize: '.16rem',
                    textAlign: textAlign,
                }}
            />
            <TextModule
                data={{ text: data.title }}
                cssStyle={{
                    fontFamily: 'var(--font-family-Bold)',
                    margin: '.06rem 0 0 0',
                    lineHeight: '.34rem',
                    fontSize: '.24rem',
                    textAlign: textAlign,
                }}
            />
            <TextModule
                data={{ text: data.desc1 }}
                cssStyle={{
                    fontFamily: 'var(--font-family-Medium)',
                    margin: '.08rem 0 0 0',
                    lineHeight: '.22rem',
                    fontSize: '.14rem',
                    color: 'rgb(34,34,34)',
                    textAlign: textAlign,
                    padding: locale === 'cn' ? '0 .4rem' : '0 .45rem',
                }}
            />
            <TextModule
                data={{ text: data.desc2 }}
                cssStyle={{
                    fontFamily: 'var(--font-family-Medium)',
                    lineHeight: '.22rem',
                    fontSize: '.14rem',
                    color: 'rgb(34,34,34)',
                    textAlign: textAlign,
                }}
            />
            <List className="listBox">
                {data?.items.map((item: any, k: number) => (
                    <Item className="list" key={k}>
                        <div className="img">
                            {Array.isArray(item?.url) ? (
                                <EFPic name={item.url} className="fullImgs" alt={item.guide} />
                            ) : (
                                <Image src={item.url} layout="fill" className="fullImgs" alt={item.guide} />
                            )}
                        </div>
                        <p className="guide font-family-medium">{item.guide}</p>
                        <p className="title font-family-extrabold">
                            <span className="titleLeft">{item.titleLeft}</span>
                            <span className="titleRight">{item.titleRight}</span>
                        </p>
                        <p className="desc font-family-bold">{item.desc}</p>
                    </Item>
                ))}
            </List>
            <TextModule
                data={{ text: data.supliment }}
                cssStyle={{
                    fontClass: 'font-family-medium',
                    margin: '0.16rem auto 0',
                    color: 'rgb(145,145,145)',
                    fontSize: '.12rem',
                    lineHeight: '.16rem',
                    textAlign: textAlign,
                }}
            />
        </div>
    );
}
